import pc11 from './images/IMG_r1_1_1.jpeg'
import pc12 from './images/IMG_r1_1_2.jpeg'
import pc13 from './images/IMG_r1_1_3.jpeg'
import pc14 from './images/IMG_r1_2_1.jpeg'
import pc15 from './images/IMG_r1_2_2.jpeg'
import pc16 from './images/IMG_r1_1.jpeg'
import pc17 from './images/IMG_r1_1_w.jpeg'
import pc10 from './images/room11.png'

import pc20 from './images/room22.png'
import pc21 from './images/IMG_r2_1_1.jpeg'
import pc22 from './images/IMG_r2_1_2.jpeg'
import pc23 from './images/IMG_r2_2_1.jpeg'
import pc24 from './images/IMG_r2_3_1.jpeg'
import pc25 from './images/IMG_r2_2_2.jpeg'
import pc26 from './images/IMG_r2_2.jpeg'
import pc27 from './images/IMG_r1_1_w.jpeg'

import pc30 from './images/room33.png'
import pc31 from './images/IMG_r3_4.jpg'
import pc32 from './images/IMG_r3_5.jpg'
import pc33 from './images/IMG_r3_6.jpg'
import pc34 from './images/IMG_r3_8.jpeg'
import pc35 from './images/IMG_r3_w.jpeg'

import pc1 from './images/room11.png'
import pc2 from './images/room22.png'
import pc3 from './images/room33.png'

import tara from './images/tara.jpg'
import scadar from './images/scadar.jpg'
import kotor from './images/kotor.jpg'
import petrovich from './images/petrovich.jpg'
import plaza from './images/plaza.jpg'





export const images_1 = [
  {
    original: pc11,
    originalHeight: 'auto',

  },
  {
    original: pc12,
    originalHeight: 'auto',


  },
  {
    original: pc13,
    originalHeight: 'auto',


  },
  {
    original: pc14,
    originalHeight: 'auto',


  },
  {
    original: pc15,
    originalHeight: 'auto',


  },
  {
    original: pc16,
    originalHeight: 'auto',


  },
  {
    original: pc17,
    originalHeight: 'auto',


  },
  {
    original: pc10,
    originalHeight: 'auto',


  },
];

export const images_2 = [
  {
    original: pc20,
    originalHeight: 'auto',

  },
  {
    original: pc21,
    originalHeight: 'auto',


  },
  {
    original: pc22,
    originalHeight: 'auto',


  },
  {
    original: pc23,
    originalHeight: 'auto',


  },
  {
    original: pc24,
    originalHeight: 'auto',


  },
  {
    original: pc25,
    originalHeight: 'auto',


  },
  {
    original: pc26,
    originalHeight: 'auto',


  },
  {
    original: pc27,
    originalHeight: 'auto',


  },
];



export const images_3 = [
  {
    original: pc30,
    originalHeight: 'auto',

  },
  {
    original: pc31,
    originalHeight: 'auto',


  },
  {
    original: pc32,
    originalHeight: 'auto',


  },
  {
    original: pc33,
    originalHeight: 'auto',


  },
  {
    original: pc34,
    originalHeight: 'auto',


  },
  {
    original: pc35,
    originalHeight: 'auto',


  },
  
];

export const images = [
  {
    original: pc1,
    originalHeight: 'auto',

  },
  {
    original: pc2,
    originalHeight: 'auto',


  },
  {
    original: pc3,
    originalHeight: 'auto',


  },
  
];

export const room_1 = [
	pc10, pc11, pc12, pc13, pc14, pc15, pc16, pc17
	]

export const room_2 = [
	pc20, pc21, pc22, pc23, pc24, pc25, pc26, pc27
	]

export const room_3 = [
	pc30, pc31, pc32, pc33, pc34, pc35
	]

export const rooms = [
	pc1, pc2, pc3
	]

export const more = {
	tara, 
	scadar, 
	kotor, 
	petrovich, 
	plaza
	}
